import React__default, { Children } from 'react';

var SlotContainer = function SlotContainer(_ref) {
  var SlotPlaceholder = _ref.SlotPlaceholder,
    children = _ref.children,
    numItems = _ref.numItems;
  var childrenByIndex = {};
  var items = [];
  if (process.env.NODE_ENV !== "production") {
    Children.forEach(children, function (child) {
      if (isNaN(child.props.idx)) {
        throw new TypeError("Child to <SlotContainer /> is missing idx property.");
      }
    });
  }
  Children.forEach(children, function (child) {
    childrenByIndex[child.props.idx] = child;
  });
  for (var i = 0; i < numItems; i++) {
    items.push(childrenByIndex[i] || /*#__PURE__*/React__default.createElement(SlotPlaceholder, {
      key: i,
      idx: i
    }));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, items);
};

export { SlotContainer };
//# sourceMappingURL=slot-container.js.map
